import DestinationTripsTemplate from "./DestinationTripsTemplate";
import { Ship } from "lucide-react";

const DisneyCruise = () => {
  return (
    <DestinationTripsTemplate
      destinationId="disney_cruise"
      destinationName="Disney Cruise Line"
      destinationIcon={Ship}
      destinationDescription="Create magical Disney cruise experiences for your clients"
      destinationFeatures="Disney Magic • Wonder • Dream • Fantasy • Wish • Caribbean • Bahamas • Alaska • Europe • Mediterranean"
    />
  );
};

export default DisneyCruise;
